exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bootstrap-wrapper input[type=radio], .bootstrap-wrapper input[type=checkbox]{\r\n    margin-top:0 !important;\r\n    position:relative !important;\r\n    margin-right:5px !important;\r\n}\r\n\r\n\r\n.bootstrap-wrapper .checkbox label{\r\n    display:flex !important;\r\n    align-items: center !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/css-loader!../css/bootstrap-fix.css
// module id = 261
// module chunks = 0